import React from 'react';
import IFaqArticle from '../interfaces/IFaqArticle';

const useFaqArticlesPublic = () => {
	const faqArticles: IFaqArticle[] = [
		{
			title: {
				en: 'What can I do if I cannot sign in?',
				fr: "Que puis-je faire si je n'arrive pas à me connecter ?",
			},
			content: {
				en: (
					<>
						Check that you are not using an incorrect email address as login or a wrong password. Your
						account may also be unactive or locked. See below for additional information or contact our
						support team:{' '}
						<a href="mailto:help@sienna-im.com" target="_blank" rel="noreferrer">
							help@sienna-im.com
						</a>{' '}
					</>
				),
				fr: (
					<>
						Vérifiez que vous n&apos;utilisez pas une adresse erronée pour vous connecter ou que votre mot
						de passe est correct. Votre compte peut aussi être inactif ou bloqué. Référez-vous aux sections
						suivantes pour toute information complémentaire ou contactez notre équipe support :{' '}
						<a href="mailto:help@sienna-im.com" target="_blank" rel="noreferrer">
							help@sienna-im.com
						</a>{' '}
					</>
				),
			},
		},
		{
			title: {
				en: 'How do I reset my password ?',
				fr: 'Comment puis-je réinitialiser mon mot de passe ?',
			},
			content: {
				en: (
					<>
						To reset your password, click on “Reset Password” on the Sign In page. Enter your email address
						and click on “Reset” button. You will receive shortly an email with a link to reset your
						password. If you don&apos;t receive an email, the email might be in your spam folder (please
						check it) or you may be using an incorrect email address.
					</>
				),
				fr: (
					<>
						Pour réinitialiser votre mot de passe, cliquez sur « changer mot de passe » sur la page de
						connexion. Saisissez votre adresse email et cliquez sur le bouton « réinitialiser ». Vous
						recevrez ensuite un email avec un lien pour réinitialiser votre mot de passe. Si vous ne recevez
						pas l&apos;email, pensez à vérifier vos dossier spams ou bien votre adresse email est erronée.
					</>
				),
			},
		},
		{
			title: {
				en: 'How can I get my login email address ?',
				fr: 'Comment puis-je connaitre mon adresse email de connexion ?',
			},
			content: {
				en: (
					<>
						If you cannot remember your email address, please contact our support team:{' '}
						<a href="mailto:help@sienna-im.com" target="_blank" rel="noreferrer">
							help@sienna-im.com
						</a>
					</>
				),
				fr: (
					<>
						Si vous ne vous souvenez pas de votre adresse email de connexion, contactez notre équipe support
						:{' '}
						<a href="mailto:help@sienna-im.com" target="_blank" rel="noreferrer">
							help@sienna-im.com
						</a>
					</>
				),
			},
		},
		{
			title: {
				en: 'How can I unlock my account ?',
				fr: 'Comment puis-je déverrouiller mon compte ?',
			},
			content: {
				en: (
					<>
						Please contact our support team:{' '}
						<a href="mailto:help@sienna-im.com" target="_blank" rel="noreferrer">
							help@sienna-im.com
						</a>{' '}
					</>
				),
				fr: (
					<>
						Merci de bien vouloir contacter notre équipe support :{' '}
						<a href="mailto:help@sienna-im.com" target="_blank" rel="noreferrer">
							help@sienna-im.com
						</a>{' '}
					</>
				),
			},
		},
		{
			title: {
				en: 'What is a two-step verification process?',
				fr: "Qu'est-ce qu'une authentification multifacteur ?",
			},
			content: {
				en: (
					<>
						Two-step verification provides an additional layer of security to your Sienna account. Two-step
						verification requires a password plus an additional authentication step to verify your identity
						when you log in.
					</>
				),
				fr: (
					<>
						Une authentification multifacteur fournit une étape complémentaire de sécurité pour vous
						permettre d&apos;accéder à votre espace client. Afin de pouvoir accéder à votre espace client,
						vous devrez donc saisir votre mot de passe et un autre moyen d&apos;authentification (code reçu
						par SMS, question secrète, code reçu par email){' '}
					</>
				),
			},
		},
		{
			title: {
				en: 'How do I change my verification process ?',
				fr: "Comment puis-je changer ma méthode d'authentification ?",
			},
			content: {
				en: <>Log in to the portal, go to your profile section and change your security method parameters</>,
				fr: (
					<>
						Connectez-vous au portail et accéder à votre profil afin de mettre à jour les méthodes de
						connexion
					</>
				),
			},
		},
		{
			title: {
				en: 'Can I use a group or share email address to access Sienna Investment Managers portal ?',
				fr: 'Puis-je utiliser un groupe email pour accéder au portail de Sienna Investment Managers ?',
			},
			content: {
				en: (
					<>
						Please contact our support team:{' '}
						<a href="mailto:help@sienna-im.com" target="_blank" rel="noreferrer">
							help@sienna-im.com
						</a>{' '}
					</>
				),
				fr: (
					<>
						Merci de bien vouloir contacter notre équipe support :{' '}
						<a href="mailto:help@sienna-im.com" target="_blank" rel="noreferrer">
							help@sienna-im.com
						</a>{' '}
					</>
				),
			},
		},
		{
			title: {
				en: 'How can I give access to Sienna Investment Managers portal to one of my colleague ?',
				fr: 'Comment puis-je demander un accès au portail de Sienna Investment Managers pour un de mes collègues ?',
			},
			content: {
				en: (
					<>
						Please contact our support team:{' '}
						<a href="mailto:help@sienna-im.com" target="_blank" rel="noreferrer">
							help@sienna-im.com
						</a>{' '}
					</>
				),
				fr: (
					<>
						Merci de bien vouloir contacter notre équipe support :{' '}
						<a href="mailto:help@sienna-im.com" target="_blank" rel="noreferrer">
							help@sienna-im.com
						</a>{' '}
					</>
				),
			},
		},
	];

	return faqArticles;
};

export default useFaqArticlesPublic;
